export default "__VITE_ASSET__D_Fz5GhO__"